'use client';
import { Modal } from '@ethsign/ui';

import React from 'react';

import { ContractDetail } from '@/components/ContractDetail';
import { ContractItem } from '@/types';

type Props = {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  contract: ContractItem | null;
  password?: string;
  showPassword?: (isShow: boolean) => void;
};
export const DetailModal = (props: Props) => {
  const { open, onOpenChange, contract, password, showPassword } = props;

  return (
    <Modal className="gap-0" open={open} onOpenChange={onOpenChange} footer={<div></div>}>
      <div className="text-lg font-medium text-gray-900 mb-6">Contract Details</div>
      <div className="max-h-[600px] overflow-auto">
        {contract && (
          <ContractDetail showPassword={showPassword} password={password} inModal contract={contract}></ContractDetail>
        )}
      </div>
    </Modal>
  );
};
